module.exports = __webpack_public_path__ + "img/heroesofasgard.82a4090e.svg";